import { Injectable } from '@angular/core';

import { Http } from '@angular/http';

import { UserData } from '../../providers/user-data';
import { CommonData } from '../../providers/common-data';
import { NativeScriptHttpModule } from "nativescript-angular/http";
import { Events } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
export enum PbActions{
  None = 0,
  PrintInvoice = 1,
  Replace = 2,
  NewPeriod = 3,
  DeletePeriod = 4,
  VerlaengerungInfoPeriod = 5,
  SendInvoice = 6,
  SendReminder = 7,
  ExcelExport = 8,
  TerminatePb = 9,
  SoftDeletePeriod = 10,
}

export enum PbKategorieActions{
  None = 0,
  ShowDetail = 1,
  CopyBestellUrl = 2,
  Duplicate = 3,
  Archive = 4,
  ShowPb = 5 
}

export enum PbKategorieTyp{
  FixeDauer = 0,
  FixerZeitraum = 1,
  Permanent = 2
}

export enum Laendercode {
  SCHWEIZ = "Schweiz", ANDERE = "Andere"
}

@Injectable()
export class ParkbewilligungenData {
  data: any;
  pbResult : any;
  pbdetail: any;
  pbcategories: any;
  pbstatus: any;
  newpbid: any;
  newpbmessage :string;
  selectedAction: PbActions;
  selectedKategorieAction: PbKategorieActions;
  selectedKategorie: any;
  selectedKunde: any;
  periodgroups: any;
  createnewperiod: any; 
  payments:any;
  periodicReload:any;
  filterPbKat:string;
  filterPbZone:string;
  added_pbkategorie_ids;
  removed_pbkategorie_ids;

  public KANTONE = ["AG", "AI", "AR", "BE", "BL", "BS", "FR", "GE", "GL", "GR", "JU", "LU", "NE", "NW", "OW", "SG", "SH", "SO", "SZ", "TG", "TI", "UR", "VD", "VS", "ZG", "ZH"];
  
  constructor(public http: Http, public common: CommonData
    , public userData: UserData
    , public events: Events
    , public alertCtrl: AlertController
    
      ) {
    this.data = [];
    this.selectedAction = PbActions.None;
    this.selectedKategorieAction = PbKategorieActions.None;
    this.selectedKategorie = null;
    this.filterPbKat = "";
    this.filterPbZone = "";
    this.added_pbkategorie_ids = [];
    this.removed_pbkategorie_ids = [];    

  }

  load(){
    this.loadcategories();
    this.loadstatus();
    this.loadperiodgroups();
    clearTimeout(this.periodicReload);
    this.periodicReload = setTimeout(() => {  
      this.load();
    }, 1000*30);      
  }

  index(_loadperiodcount = false, _pbstatusfilter = null){
    return new Promise(resolve => {
      let params = JSON.stringify({ token: this.userData.jwt, loadoldpb: this.userData.loadoldpb, loadperiodcount:_loadperiodcount, pbstatusfilter:_pbstatusfilter});    

      this.http.post(this.common.baseurl+'parkbewilligungen/index',params)
        .subscribe(data => {          
          let response = data.json();
          if(response.success === true){
              this.data = response.data;
              //console.log(this.data);
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.data = [];
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }  

  viewallbycustomer(pbkunden_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkunden_id: pbkunden_id
        ,token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'parkbewilligungen/viewallbycustomer',params)
        .subscribe(data => {
          
          let response = data.json();
          //console.log(response);
          
          if(response.success === true){
            //console.log(response.data);  
            this.pbdetail = response.data;
            //console.log(this.pbdetail);
            resolve(this.pbdetail);
          }
          else{  
            //this.kont.error = response.message;
            this.pbdetail = {};
            resolve(this.pbdetail);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve(this.pbdetail);  
      });
    });   
  }  

  terminate(perioden_ids, enddatum){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        perioden_ids: perioden_ids
        ,enddatum: enddatum
        ,token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'parkbewilligungen/terminate',params)
        .subscribe(data => {          
          let response = data.json();
          resolve(response);
        }, error => {
          resolve(null);  
      });
    });       
  }  

  loadperiodgroups(){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        token: this.userData.jwt
      });    
      if (!this.userData.isAllowed('17','r')){
        resolve([]);
      }
      this.http.post(this.common.baseurl+'parkbewilligungen/periodgroups',params)
        .subscribe(data => {
          
          let response = data.json();
          if(this.periodgroups){
            //-- only update recordcounts ----
            for(let i=0; i<this.periodgroups.length; i++){
              this.periodgroups[i].recordcount = response.data[i].recordcount;
            }
          }
          else{
            this.periodgroups = response.data;
          }
          if(this.periodgroups && this.periodgroups.length > 0){
            let taskcounter = 0;
            for(let i=0; i<this.periodgroups.length; i++){
              if(this.periodgroups[i].showrecordcount){
                taskcounter += this.periodgroups[i].recordcount;
              }
            }
            //console.log("load period groups");
              this.events.publish('updatecounter', "Aufgaben" ,taskcounter);          
            
          }
          if(response.success === true){            
              resolve(this.periodgroups);
          }
          else{  
            resolve(this.periodgroups);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(this.periodgroups);  
      });


    });   

  }

  updatepbkunde(pbkunde, pbkennzeichen){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkunde: pbkunde
        ,pbkennzeichen: pbkennzeichen
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/updatepbkunde',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){      
              //this.pbdetail = response.data;            
              resolve(response.data);
          }
          else{  
            //this.kont.error = response.message;
            resolve(false);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }

  createpbkunde(pbkunde, pbkennzeichen){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkunde: pbkunde
        ,pbkennzeichen: pbkennzeichen
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbkunden/create',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){      
              //this.pbdetail = response.data;            
              resolve(response.data);
          }
          else{  
            //this.kont.error = response.message;
            resolve(false);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }

  pbkennzeichenInUse(pbkennzeichen_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkennzeichen_id: pbkennzeichen_id
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbkennzeichens/inuse',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){      
              //this.pbdetail = response.data;            
              resolve(response.data);
          }
          else{  
            //this.kont.error = response.message;
            resolve(false);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }

  existingParkkarten(pbkunden_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkunden_id: pbkunden_id
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/existingparkkarten',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){      
              //this.pbdetail = response.data;            
              resolve(response.data);
          }
          else{  
            //this.kont.error = response.message;
            resolve(false);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }  

  updatepbperiode(pbperiode){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbperiode: pbperiode
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/updatepbperiode',params)
        .subscribe(data => {
          let response = data.json();
          resolve(response);
        }, error => {
          resolve(false);  
      });
    });    

  }
  createpbperiode(pbperiode, physisch){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        physisch: physisch
        ,pbperiode: pbperiode
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/createpbperiode',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });    

  }
  

  paymentsforperiod(periode_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        period_id: periode_id
        ,token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'parkbewilligungen/paymentsforperiod',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();

          if(response.success === true){            
              //this.payments = response.data;            
              resolve(response.data);
          }
          else{  
            //this.kont.error = response.message;
            //this.payments = {};
            resolve(response.data);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve([]);  
      });
    });   
  }

  

  
  cloneperiods(pbperiod_ids, newperiodvalues){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbperiod_ids: pbperiod_ids
        ,newperiodvalues:newperiodvalues
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/cloneperiods',params)
        .subscribe(data => {
          //console.log("cloneperiods");
          //console.log(data);
          let response = data.json();
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });    

  }
  deleteperiods(pbperiod_ids){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbperiod_ids: pbperiod_ids
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/deleteperiods',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });    
  }

  
  softdeleteperiods(pbperiod_ids){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbperiod_ids: pbperiod_ids
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/softdeleteperiods',params)
        .subscribe(data => {
          let response = data.json();
          resolve(response);
        }, error => {
          resolve(false);  
      });
    });    
  }  
  periodenverlaengerungsinfo(pbperiod_ids){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbperiod_ids: pbperiod_ids
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/periodenverlaengerungsinfo',params)
        .subscribe(data => {
          let response = data.json();
          //console.log(response);
          if(response.success){
            let alert = this.alertCtrl.create();
            let title = response.data.email+" E-Mails verschickt und "+ response.data.pdf + " PDF-Briefe erzeugt.";
            alert.setTitle(title);
            alert.addButton({
              text: 'Ok',
              handler: (data: any) => {
                if(response.data.pdf>0){
                  window.open(this.common.filesurl+response.data.zip, "_blank");
                }
  
              }
            });
   
            alert.present();  
          }
    
          else{  
            console.error(response.message);
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });    


  }
  assignnextperiodstate(pbperiode_id, action_result){
    
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbperiode_id: pbperiode_id
        ,action_result: action_result
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/assignnextperiodstate',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });       
  }
  
  async bestellungAblehnen(pbperiode_id, grund){
    return new Promise(resolve => {        
      let params = JSON.stringify({ 
        token: this.userData.jwt,
        pbperiode_id: pbperiode_id,
        grund: grund
      });    

      this.http.post(this.common.baseurl+'parkbewilligungen/ablehnen',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){
              resolve(response);         
          }
          else{  
            resolve(false);
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);
      });
    }); 

  }

  pbcatbyid(pbcat_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbcat_id: pbcat_id
        ,token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'parkbewilligungen/pbcatbyid',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);

          if(response.success === true){
      
              //this.pbdetail = response.data;            
              resolve(response.data);
          }
          else{  
            //this.kont.error = response.message;
            this.pbdetail = {};
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }    

  loadcategories(){
    return new Promise(resolve => {

      let params = JSON.stringify({ 
        token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'parkbewilligungen/pbcategories',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){
              //this.pbdetail = response.data;            
              this.pbcategories = response.data;
              resolve(response.data);
          }
          else{  
            resolve(false);
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);
          console.log('error loading categories');
      });
    });   

  }
  getPbcategories(searchQuery: string = ''){    
    let keyword = searchQuery.toLocaleLowerCase();
    
    let cat = this.pbcategories.filter((item) => {
      let keywordfound = true;
      if(keyword !== '' && item.name){        
        keywordfound = item.name.toString().toLowerCase().includes(keyword)
      }
      
      return (item.archiviert == 0)  && keywordfound && item.id>0;
    });

    return cat;
    
  }
  getPbcat(pbkat_id: number){
    let cats = this.pbcategories.filter((item) => {
      return (item.id == pbkat_id);
    });
    if(cats && cats.length>0){
      return cats[0];
    }
  }
  updatepbkategorie(pbkat){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkat: pbkat
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/updatepbkategorie',params)
        .subscribe(data => {
          let response = data.json();
          //console.log(response);
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });    

  }
  updatepbkategorieregeln(pbkategorie_id, pbkatregeln){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkategorie_id: pbkategorie_id
        ,pbkatregeln: pbkatregeln
        ,token: this.userData.jwt
      });    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/updatepbkategorieregeln',params)
        .subscribe(data => {
          let response = data.json();          
          if(response.success === true){   
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });      
  }
  createpbkategorie(pbkat){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkat: pbkat
        ,token: this.userData.jwt
      });    

      this.http.post(this.common.baseurl+'parkbewilligungen/createpbkategorie',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){   
              this.added_pbkategorie_ids.push(response.data.id);
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });    

  }  
  deletepbkategorie(pbkat_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        id: pbkat_id
        ,token: this.userData.jwt
      });    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/deletepbkategorie',params)
        .subscribe(data => {
          let response = data.json();
          //console.log(response);
          if(response.success === true){   
              this.removed_pbkategorie_ids.push(response.data.id);
              resolve(response.data);
          }
          else{  
            resolve(false);              
          }
        }, error => {
          resolve(false);  
      });
    });    

  }  

  

  pbregelnbycatid(pbcat_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbcat_id: pbcat_id
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'parkbewilligungen/pbregelnbycatid',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){      
              //this.pbdetail = response.data;            
              resolve(response.data);
          }
          else{  
            //this.kont.error = response.message;
            resolve(false);              
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }

  pbcountbycatid(pbcat_id){
    return new Promise(resolve => {
      let params = JSON.stringify({ 
        pbkategorie_id: pbcat_id
        ,token: this.userData.jwt
      });    
      this.http.post(this.common.baseurl+'pbkategorien/periodcount',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          resolve(response);
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }

  async checkPbById(pbid, grundid) {
    return new Promise(resolve => {
      let params = JSON.stringify({pbid:pbid, grundid:grundid, token: this.userData.jwt});    

      this.http.post(this.common.baseurl+'parkbewilligungen/checkpbbyid',params)
        .subscribe(data => {
          
          let response = data.json();
          console.log(response);
          //console.log(response);

          if(response.success === true){
            
              this.pbResult = response.data;
            
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.pbResult = null;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }

  async checkPbByUrlIdent(urlident, grundid) {
    return new Promise(resolve => {
      let params = JSON.stringify({urlident:urlident, grundid:grundid, token: this.userData.jwt});    
      console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/checkpbbyurlident',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          console.log(response);

          if(response.success === true){
            
              this.pbResult = response.data;
            
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.pbResult = null;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  } 

  checkPbByPlate(plate, grundid, kontid){
    return new Promise(resolve => {
      let params = JSON.stringify({plate:plate, grundid:grundid, token: this.userData.jwt, checkexternal: true, kontid:kontid});    
      this.http.post(this.common.baseurl+'parkbewilligungen/checkpbbyplate',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          if(response.success === true){
            
              this.pbResult = response.data;
            
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.pbResult = null;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });   
  }
  
  async assignNewPb(pbid){
    return new Promise(resolve => {
      let params = JSON.stringify({oldpbid:pbid, token: this.userData.jwt});    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/assignnewpb',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          console.log(response);

          if(response.success === true){            
              this.newpbid = response.data;            
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.newpbmessage = response.message;
            this.newpbid = -1;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }

  async printinvoices(pbperioden_ids){
    return new Promise(resolve => {
      let params = JSON.stringify({pbperioden_ids:pbperioden_ids, token: this.userData.jwt});    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/printinvoices',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){      
            if(response.data != ""){
              window.open(this.common.filesurl+response.data.zip, "_blank");
            }
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.newpbmessage = response.message;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }

  async printinvoices_no_statechange(pbperioden_ids){
    return new Promise(resolve => {
      let params = JSON.stringify({pbperioden_ids:pbperioden_ids, token: this.userData.jwt});    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/printinvoicesnostatechange',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){      
            if(response.data != ""){
              window.open(this.common.filesurl+response.data.zip, "_blank");
            }
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.newpbmessage = response.message;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }  

  async sendpbchangenotification(pbperioden_ids){
    return new Promise(resolve => {
      let params = JSON.stringify({pbperioden_ids:pbperioden_ids, token: this.userData.jwt});    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/sendpbchangenotification',params)
        .subscribe(data => {
          let response = data.json();
          if(response.success === true){      
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.newpbmessage = response.message;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });      
  }
  

  async sendinvoices(pbperioden_ids, forcepdf){
    return new Promise(resolve => {
      let params = JSON.stringify({pbperioden_ids:pbperioden_ids, forcepdf:forcepdf, token: this.userData.jwt});    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/sendinvoices',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();

          if(response.success === true){      
            let alert = this.alertCtrl.create();
            let title = response.data.email+" E-Mails verschickt und "+ response.data.pdf + " PDF-Briefe erzeugt.";
            alert.setTitle(title);
            alert.addButton({
              text: 'Ok',
              handler: (data: any) => {
                if(response.data.pdf>0){
                  window.open(this.common.filesurl+response.data.zip, "_blank");
                }
              }
            });   
            alert.present();  
            resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.newpbmessage = response.message;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }
  async sendreminders(pbperioden_ids, forcepdf){
    return new Promise(resolve => {
      let params = JSON.stringify({pbperioden_ids:pbperioden_ids, forcepdf:forcepdf, token: this.userData.jwt});    
      console.log("send reminders!!!");
      this.http.post(this.common.baseurl+'parkbewilligungen/sendreminders',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();

          if(response.success === true){      
            let alert = this.alertCtrl.create();
            let title = response.data.email+" E-Mails verschickt und "+ response.data.pdf + " PDF-Briefe erzeugt.";
            alert.setTitle(title);
            alert.addButton({
              text: 'Ok',
              handler: (data: any) => {
                if(response.data.pdf>0){
                  window.open(this.common.filesurl+response.data.zip, "_blank");
                }
              }
            });   
            alert.present();  
            resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            this.newpbmessage = response.message;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }

  async pbssent(pbperioden_ids){
    return new Promise(resolve => {
      let params = JSON.stringify({pbperioden_ids:pbperioden_ids, token: this.userData.jwt});    
      //console.log(params);
      this.http.post(this.common.baseurl+'parkbewilligungen/pbssent',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          console.log(response);
          if(response.success === true){      
              resolve(true);
          }
          else{  
            //this.kont.error = response.message;
            //this.newpbmessage = response.message;
            resolve(false);  
            
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);  
      });
    });       
  }

  loadstatus(){
    let params = JSON.stringify({ 
      token: this.userData.jwt
    });    

    this.http.post(this.common.baseurl+'parkbewilligungen/pbstatus',params)
      .subscribe(data => {
        //console.log(data);
        let response = data.json();
        //console.log(response);
        if(response.success === true){
            //this.pbdetail = response.data;            
            this.pbstatus = response.data;
        }
        else{  
        }
      //resolve([this.data]);          
      }, error => {
        console.log('error loading pbstatus');
    });

  }
  pbstatusnameid(status_id){
    //console.log(ppid);
    let i=0;
    for(i=0; i<this.pbstatus.length; i++){
      if(this.pbstatus[i].id == status_id){
        //console.log(this.data[i].kurzname);
        return this.pbstatus[i].name;                
      }
    }
    return status_id;    
  }  

  async getKategorieBestellURL(pbkat_id: number){
    let pbkat = await this.getPbcat(pbkat_id);
    if(pbkat){
      return '/bestellen2?k='+pbkat.id+'&m='+pbkat.mandate_id;
    }
    else{
      return 'nach dem Speichern ersichtlich';
    }

  }



  async copyKategorie(pbkat_id: number){
    return new Promise(resolve => {        
      let params = JSON.stringify({ 
        token: this.userData.jwt,
        pbkategorie_id: pbkat_id
      });    

      this.http.post(this.common.baseurl+'pbkategorien/copy',params)
        .subscribe(data => {
          //console.log(data);
          let response = data.json();
          //console.log(response);
          if(response.success === true){
              resolve(response.data);         
          }
          else{  
            resolve(false);
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);
      });
    }); 

  }

  async archiveKategorie(pbkat_id: number){
    return new Promise(resolve => {        
      let params = JSON.stringify({ 
        token: this.userData.jwt,
        pbkategorie_id: pbkat_id
      });    

      this.http.post(this.common.baseurl+'pbkategorien/archive',params)
        .subscribe(data => {
          let response = data.json();
          //console.log(response);
          if(response.success === true){
              resolve(response.data);         
          }
          else{  
            resolve(false);
          }
        //resolve([this.data]);          
        }, error => {
          resolve(false);
      });
    }); 
  }
  getBestelltypName(bestelltyp: number){
    switch (bestelltyp) {
      case PbKategorieTyp.FixeDauer: 
        return "Fixe Dauer"; 
      case PbKategorieTyp.FixerZeitraum:
        return "Fixer Zeitraum";         
      case PbKategorieTyp.Permanent:
        return "permanent"; 
    }
  }


  copyTextClipboard(val: string){
    //val = +val;
    let selBox = document.createElement('textarea');
      selBox.style.position = 'fixed';
      selBox.style.left = '0';
      selBox.style.top = '0';
      selBox.style.opacity = '0';
      selBox.value = val;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand('copy');
      document.body.removeChild(selBox);
    }  

}



// WEBPACK FOOTER //
// ./src/pages/parkbewilligungen/parkbewilligungen-data.ts